// eslint-disable-next-line no-unused-vars
import { React, useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
	InformationsWrapper,
	ActivityWrapper,
	FormGroup,
} from "../customersPage.styled";
import { Button } from "../../Products/Forms/ProductForm.styled";
import FormAccordion from "../../../components/Form/FormAccordion";
import { getCustomerInfo } from "../customersUtils";
import { toast } from "react-toastify";
import { useParams, useNavigate, useOutletContext } from "react-router";
import { Backdrop, CircularProgress } from "@mui/material";
// import { getFormattedAmount } from "../../../utils/AmountUtils";
import { getFormattedDate } from "../../../utils/DateUtils";
import { FileGroup } from "../../../components/Form/FormComponents";
import { AiOutlineDelete } from "react-icons/ai";
import ConfirmModal from "../../../components/ConfirmModal";
import { handleCustomerDeletion } from "../customersUtils";
// eslint-disable-next-line no-unused-vars
function Information() {
	const navigate = useNavigate();
	const { id } = useParams();
	const customerData = useOutletContext();

	const [data, setData] = useState();
	const [loading, setLoading] = useState(true);
	const [confirmModal, setConfirmModal] = useState(false);

	const deleteCustomer = async () => {
		setLoading(true);
		let data = await handleCustomerDeletion([id]);
		try {
			if (data.result) {
				// console.log(data)
				setConfirmModal(false);
				setLoading(false);
				navigate("/customer");
				customerData();
				toast.success("customer deleted successfully");
			} else {
				setLoading(false);
				toast.error("unable to delete customer, please try again later");
			}
		} catch (error) {
			setLoading(false);
			toast.error("unable to delete customer, please try again later");
		}
	};

	useEffect(() => {
		getCustomerInfo(id)
			.then((res) => {
				if (res.error) {
					setLoading(false);
					toast.error(res.error);
				} else {
					setLoading(false);
					if (res.result) {
						// console.log(res.result);
						setData(res.result);
					} else {
						toast.error("Unable to fetch customer information");
					}
				}
			})
			.catch((error) => {
				setLoading(false);
				console.log(error);
				toast.error(error);
			});
	}, []);
	/* eslint-disable no-mixed-spaces-and-tabs  */
	return (
		<InformationsWrapper>
			{confirmModal && (
				<ConfirmModal
					confirmModal={confirmModal}
					setConfirmModal={setConfirmModal}
					content={{
						title: "Delete customer",
						desc: "Are you sure you want to delete this customer?",
						btnText: "Yes, Delete",
					}}
					handleDeleteAction={deleteCustomer}
				/>
			)}
			<p className='avatar'>
				<img src='/images/UserAvatar_img.svg' alt='user image' />
			</p>

			<ActivityWrapper>
				<section className='title space-between'>
					<p>Profile status</p>
					<p>Joined date</p>
					<p>Last seen</p>
				</section>

				<section className='content space-between'>
					<p>{data?.profileStatus ? data.profileStatus : "--"}</p>
					<p>{data?.createdAt ? getFormattedDate(data?.createdAt) : "--"}</p>
					<p>{data?.lastSeen ? data.lastSeen : "--"}</p>
				</section>
			</ActivityWrapper>

			{/* map throught the data, set the header in a list and use the id as selector for the data in state */}
			<FormAccordion title='Personal profile' open={true}>
				<div className='grid grid-cols-3 gap-3'>
					<FormGroup>
						<label>Email address</label>
						<p>{data?.email ? data.email : "--"}</p>
					</FormGroup>

					<FormGroup>
						<label>Work email</label>
						<p>{data?.workEmail ? data.workEmail : "--"}</p>
					</FormGroup>

					<FormGroup>
						<label>First name</label>
						<p>{data?.firstName ? data.firstName : "--"}</p>
					</FormGroup>

					<FormGroup>
						<label>Last name</label>
						<p>{data?.lastName ? data.lastName : "--"}</p>
					</FormGroup>

					<FormGroup>
						<label>Phone number</label>
						<p>{data?.phone ? data.phone : "--"}</p>
					</FormGroup>

					<FormGroup>
						<label>Date of birth</label>
						<p>{data?.DOB ? data.DOB : "--"}</p>
					</FormGroup>

					<FormGroup>
						<label>Work status</label>
						<p>{data?.profile ? data.profile["workStatus"] : "--"}</p>
					</FormGroup>

					<FormGroup>
						<label>Employer</label>
						<p>{data?.profile ? data.profile["employers"] : "--"}</p>
					</FormGroup>

					<FormGroup>
						<label>Number of dependants</label>
						<p>{data?.profile ? data.profile["numberOfDependants"] : "--"}</p>
					</FormGroup>

					<FormGroup>
						<label>Home address</label>
						<p>{data?.profile ? data.profile["homeAddress"] : "--"}</p>
					</FormGroup>

					<FormGroup>
						<label>Id card</label>
						<FileGroup value={data?.idCard} />
					</FormGroup>

					<FormGroup>
						<label>Utility bill</label>
						<FileGroup value={data?.utilityBill} />
					</FormGroup>
				</div>
			</FormAccordion>

			<FormAccordion title='Business profile' open={true}>
				<div className='grid grid-cols-3 gap-3'>
					<FormGroup>
						<label>Business type</label>
						{data?.businessProfile["businessType"]
								? data.businessProfile["businessType"]
								: "--"}
					</FormGroup>

					<FormGroup>
						<label>Business name</label>
						<p>
							{data?.businessProfile["businessName"]
								? data.businessProfile["businessName"]
								: "--"}
						</p>
					</FormGroup>

					<FormGroup>
						<label>Business address</label>
						<p>
							{data?.businessProfile["businessAddress"]
								? data.businessProfile["businessAddress"]
								: "--"}
						</p>
					</FormGroup>

					<FormGroup>
						<label>Incorporation status</label>
						<p>
							{data?.businessProfile["incorporationStatus"]
								? data.businessProfile["incorporationStatus"]
								: "--"}
						</p>
					</FormGroup>

					<FormGroup>
						<label>Year of Incorporation</label>
						<p>
							{data?.businessProfile["incorporationYear"] ?
								data.businessProfile["incorporationYear"]
								: "--"}
						</p>
					</FormGroup>

					<FormGroup>
						{/* <div className='form-group'> */}
						<label>Certificate of Incorporation</label>
						<FileGroup value={data?.certificateOfIncorporation} />
					</FormGroup>
					{/* </div> */}
				</div>
			</FormAccordion>

			<FormAccordion title='Investor profile' open={true}>
				<div className='grid grid-cols-3 gap-3'>
					<FormGroup>
						<label>Net worth</label>
						<p>{data?.investorProfile["netWorth"] || "--"}</p>
					</FormGroup>

					<FormGroup>
						<label>E-signature</label>
						<p>{data?.witnessSignature ? data?.witnessSignature : "--"}</p>
					</FormGroup>

					<Button
						type='button'
						onClick={() => {
							setConfirmModal(true);
						}}
						customwidth='13rem'
						backgroundcolor='#FF7878'
						color='#ffffff'
					>
						<AiOutlineDelete size={20} />
						<p>Delete customer</p>
					</Button>

					{/* <FormGroup>
					 <label>E-signature</label>
						<FileGroup name='idCard' value={data?.witnessSignature} />
					</FormGroup>  */}
				</div>

				{loading && (
					<Backdrop
						sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
						open={loading}
					>
						<CircularProgress color='inherit' />
					</Backdrop>
				)}
			</FormAccordion>
		</InformationsWrapper>
	);
}

Information.propTypes = {
	customerData: PropTypes.func,
};

export default Information;
